export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only run on client side
  if (import.meta.server) return

  try {
    const token = to.query.token

    // Check if token exists in query params
    if (token && typeof token === 'string') {
      // Skip token authentication for routes that handle tokens differently
      const skipRoutes = [
        '/account/confirm', // Double opt-in confirmation uses token for subscription
      ]

      // Check if current path matches any skip route
      if (skipRoutes.some((route) => to.path.includes(route))) {
        return
      }

      const authentication = useAuthentication()

      // Attempt to authenticate with the token
      const success = await authentication.authenticateWithToken(token)

      if (success) {
        // Check if this is a password reset confirmation
        const isPasswordReset = to.query.type === 'confirm-reset-password'

        if (!isPasswordReset) {
          // Remove token from URL for security (optional but recommended)
          const query = { ...to.query }
          delete query.token

          // Navigate to the same route without the token in the URL
          return navigateTo(
            {
              path: to.path,
              query,
              hash: to.hash,
            },
            {
              replace: true, // Replace history entry to prevent back button showing token
            },
          )
        }
        // For password reset confirmation, keep the token in the URL
      } else {
        console.warn('Token authentication failed')
      }
    }
  } catch (e) {
    console.error('Error during token authentication:', e)
  }
})
